<div class="page-container">
  <h1>Kontaktiere uns</h1>
  <p>Hast du Fragen oder Feedback? Schreib uns eine E-Mail – wir helfen dir gerne weiter!</p>
  <div class="email" (click)="sendEmail()">
    <i-tabler name="mail"></i-tabler>
    <span>{{'info@sparklycards.com'}}</span>
  </div>
  <app-button [text]="'E-Mail schreiben'" [leftIcon]="'mail'" (clickEvent)="sendEmail()"></app-button>
</div>